import { useState } from "react";
import { useSelector } from "react-redux";
// @mui material components
import { LinearProgress } from "@mui/material";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import Sales from "../details";

const columns = [
  { Header: "cours", accessor: "course", width: "70%", align: "left" },
  { Header: "nombre de ventes", accessor: "count", align: "center" },
];

function formatDate(date) {
  const today = date.split("-");
  const dd = today[0];

  const mm = parseInt(today[1], 10) - 1;
  const yyyy = today[2];

  return new Date(yyyy, mm, dd);
}

const countData = (dateDebut, dateFin, subscriptions) => {
  let currentData = subscriptions;
  if (dateDebut !== null)
    currentData = currentData.filter((s) => dateDebut <= formatDate(s.createdAt));
  if (dateFin !== null) currentData = currentData.filter((s) => formatDate(s.createdAt) <= dateFin);

  return currentData.length;
};

export default function data({ dateDebut, dateFin }) {
  const fetched = useSelector((state) => state.course.fetched);
  const courses = useSelector((state) => state.course.allCourses);
  const [currentCourse, setCurrentCourse] = useState(null);
  const [dialog, setDialog] = useState(false);

  const finished = () => {
    setCurrentCourse(null);
    setDialog(false);
  };

  const rows = courses.map((course) => ({
    course: (
      <MDTypography
        sx={{ cursor: "pointer" }}
        onClick={(e) => {
          e.preventDefault();
          setCurrentCourse(course);
          setDialog(true);
        }}
        variant="caption"
        color="text"
        fontWeight="medium"
      >
        {course.wording}
      </MDTypography>
    ),
    count: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {countData(dateDebut, dateFin, course.subscriptions)}
      </MDTypography>
    ),
  }));

  return (
    <>
      <MDBox pt={3} sx={{ overflowX: "hidden" }}>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
        />
        {!fetched && <LinearProgress color="info" />}
      </MDBox>
      {dialog && <Sales data={currentCourse} dataType="course" finished={finished} />}
    </>
  );
}
